module.exports = __webpack_public_path__ + "img/mail.1ab23f2c.png";